import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import './index.scss';
import { Document } from 'components/Documents';
import { showError } from 'utils';
import { fetchPaginatedMedia } from 'services';
import { Loading } from 'components/loading/Loading';
import CreateMediaModal from 'components/MediaComponentModel';
import ActionButton from 'components/ActionButton';

const Media = (props) => {
  const [media, setMedia] = useState<Array<string>>([]);
  const [query, setQuery] = useState('');
  const [filteredMedia, setFilteredMedia] = useState<Array<string>>([]);
  const [loading, setLoading] = useState(true);
  const [paginationLoading, setPaginationLoading] = useState(true);
  const [loadMoreButton, setLoadMoreButton] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  let page = 0;
  const limit = 30;

  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async (isPagintion = false) => {
    setPaginationLoading(true);
    try {
      const response = await fetchPaginatedMedia(page, limit);
      let newMedia = response?.items || [];
      if (isPagintion) {
        newMedia = [...media, ...(response?.items || [])];
        setMedia(newMedia);
      } else {
        setMedia(newMedia);
      }
      setFilteredMedia(newMedia);
      setLoadMoreButton(response?.items?.length >= limit);
    } catch (error) {
      showError(error || 'Error fetching media');
    } finally {
      setLoading(false);
      setPaginationLoading(false);
    }
  };

  const handleToggleModal = () => {
    setShowModal(!showModal);
  };

  const handleItemSelected = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const Header = () => (
    <div className={styles.header}>
      <div className={styles.heading}>Media</div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={<>Media <span>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => {
            setShowModal(true);
            setSelectedItem(null);
          }}
        />
      </div>
    </div>
  );

  function MediaList(): JSX.Element[] | any {
    return (
      filteredMedia.map((mediaItem: any, index): JSX.Element => (
        <div key={index} className='col-6 col-md-3 col-lg-2 text-center document-container'>
          <div className='source'>{mediaItem?.name}</div>
          <Document doc={mediaItem} onDocumentChange={fetchMedia} onItemSelected={handleItemSelected} />
        </div>
      ))
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div className='mt-4'>
      <Header />
      <div className='card'>
        <div className='card-header'>
          <div className='w-50'>
            <input type='text' value={query} className='form-control' placeholder='Search' onChange={(e) => {
              setQuery(e.target.value);
              if (e.target.value === '') {
                setFilteredMedia(media);
              } else {
                setFilteredMedia(media.filter((item: any) => { return item?.name?.includes(e.target.value) }));
              }
            }} />
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <MediaList />
          </div>
        </div>
      </div>
      <CreateMediaModal showModal={showModal} toggleModal={handleToggleModal} itemSelected={selectedItem} onSuccess={fetchMedia} />
      <div className='d-flex justify-content-center mt-4'>
        {loadMoreButton && (
          <ActionButton
            text='Load More'
            active={true}
            isLoading={paginationLoading}
            onClick={() => {
              page++;
              fetchMedia(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Media;